export const hasItems = (items) => !!items && items.length > 0;
export const isLastItem = (array, index) => index === array.length - 1;
export const mapWithAssert = (array, callback) => array.map(callback);
